import { apiClient } from './api'

export interface CapacityCell { week: string; hours: number; load: number | null }
export interface CapacityTask {
  id: number; title: string; project_id: number; project_name: string
  due_date: string | null; hours: number; overdue: boolean; status: string
}
export interface CapacityPerson {
  user_id: number
  name: string
  hours_per_week: number
  weeks: CapacityCell[]
  total_hours: number
  utilization: number | null
  peak_load: number
  over_weeks: number
  overdue_hours: number
  later_hours: number
  projects: Array<{ id: number; name: string; hours: number }>
  tasks: CapacityTask[]
}
export interface CapacityOverview {
  weeks: string[]
  people: CapacityPerson[]
  unassigned: { weeks: number[]; total_hours: number; overdue_hours: number }
  summary: {
    people: number; without_work: number; over_allocated: number; under_used: number
    utilization: number | null; unassigned_hours: number
  }
}

export const capacityService = {
  async overview(weeks = 8): Promise<CapacityOverview> {
    const { data } = await apiClient.get<CapacityOverview>('/api/v1/capacity', { params: { weeks } })
    return data
  },
  async setHours(userId: number, hours: number | null): Promise<{ user_id: number; hours_per_week: number }> {
    const { data } = await apiClient.put(`/api/v1/capacity/people/${userId}`, { hours_per_week: hours })
    return data
  },
}
